<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Abbreviations">
<p class="fm_headts" id="loabb"><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv"><a href="#/text/Contents#loa">ABBREVIATIONS</a></span></p>
<p class="noindent_paratsa">AAN—Archiwum Akt Nowych, Archives of New Records</p>
<p class="noindent_paratsa">AIPN—Archiwum Instytut Pamięci Narodowej, Archive of the Institute of National Remembrance</p>
<p class="noindent_paratsa">AK—Armia Krajow, Home Army</p>
<p class="noindent_paratsa">AL—Armia Ludowa, People’s Army</p>
<p class="noindent_paratsa">CKŻP—Centralny Komitet Żydów w Polsce, the Central Committee of Jews in Poland</p>
<p class="noindent_paratsa">CPSSM—Commission for the Protection of Sites of Suffering and Martyrdom</p>
<p class="noindent_paratsa">FRG—Federal Republic of Germany</p>
<p class="noindent_paratsa">GDR—German Democratic Republic</p>
<p class="noindent_paratsa">JAC—Jewish Antifascist Committee</p>
<p class="noindent_paratsa">JDC—American Joint Distribution Committee</p>
<p class="noindent_paratsa">KPP—Komunistyczna Partia Polski, Communist Party of Poland</p>
<p class="noindent_paratsa">ORT—Organization for Rehabilitation through Training</p>
<p class="noindent_paratsa">PAP—Polish News Agency</p>
<p class="noindent_paratsa">PeKaO—Polska Kasa Opieki, Polish Aid Bank</p>
<p class="noindent_paratsa">PRL—Polska Rzeczpospolita Ludowa, People’s Republic of Poland</p>
<p class="noindent_paratsa">PUWP—The Polish United Workers’ Party, Polska Zjednoczona Partia Robotnicza</p>
<p class="noindent_paratsa">PWN—Państwowe Wydawnictwo Naukowe, National Scientific Publishers</p>
<p class="noindent_paratsa">TASS—Telegraph Agency of the Soviet Union</p>
<p class="noindent_paratsa">TSKŻ—Towarzystwo Społeczno-Kulturalne Żydów w Polsce, Social Cultural Association of Jews in Poland</p>
<p class="noindent_paratsa"><span class="right_1" epub:type="pagebreak" id="page_xvi" title="xvi">WZO—World Zionist Organization</span></p>
<p class="noindent_paratsa">ZBoWiD—Związek Bojowników o Wolność i Demokrację, Society of Fighters for Freedom and Democracy</p>
<p class="noindent_paratsa">ZRWM—Związek Religijny Wyznania Mojżeszowego, Religious Union of the Jewish Faith</p>
<p class="noindent_paratsa">ŻTK—Żydowskie Towarzystwo Kultury w Polsce, Jewish Cultural Society</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?4cada152